import { formValidation } from './_form-validation';
import Modal from 'bootstrap/js/dist/modal';

export const initFormStepper = () => {
    const stepElements = Array.from(
        document.querySelectorAll(
            '[data-drupal-selector^="edit-group-step-"]'
        )
    );

    if (stepElements.length === 0) {
        stepElements.push(
            ...Array.from(document.querySelectorAll('[id^="step-"]'))
        );
    }

    if (stepElements.length <= 1) return;

    const formActions =
        document.querySelector('[data-drupal-selector="edit-actions"]') ||
        document.getElementById('edit-actions');

    let activeStepIndex = 0;

    const getMissingFields = () => {
        const missing = [];
        stepElements.forEach((step) => {
            const required = formValidation.getRequiredFields(step);
            required.forEach((field) => {
                if (!formValidation.isFieldFilled(field)) {
                    const type = field.type?.toLowerCase();
                    let name;

                    if (type === 'checkbox' || type === 'radio') {
                        const fieldset = field.closest('fieldset');
                        const legend = fieldset?.querySelector('legend');
                        name = legend?.textContent?.trim();
                    }

                    if (!name) {
                        const wrapper = field.closest('.js-form-item, .form-item, fieldset');
                        const label = wrapper?.querySelector(':scope > label, :scope > legend');
                        name = label?.textContent?.trim();
                    }

                    name = name ||
                        field.getAttribute('aria-label') ||
                        field.name?.replace(/[\[\]_]+/g, ' ').trim() ||
                        'Unnamed field';

                    missing.push(name);
                }
            });
        });
        if (!stepElements.some((step) => formValidation.hasUploadedFile(step))) {
            missing.push('File upload');
        }
        return missing;
    };

    const missingFieldsModal = (() => {
        const modal = document.createElement('div');
        modal.className = 'modal fade';
        modal.id = 'missingFieldsModal';
        modal.tabIndex = -1;
        modal.setAttribute('aria-labelledby', 'missingFieldsModalLabel');
        modal.setAttribute('aria-hidden', 'true');
        modal.innerHTML = `
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="missingFieldsModalLabel">
                            Missing Fields
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p>Please complete all required fields before proceeding.</p>

                        <p>Missing required fields:</p>
                        <ul class="missing-fields-list list-group list-group-flush"></ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>`;
        document.body.appendChild(modal);
        return modal;
    })();

    const infoBtn = (() => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'button--primary js-form-submit form-submit btn btn-primary';
        btn.innerHTML = '<i class="bi bi-exclamation-diamond"></i> Complete Missing Fields to Continue';
        btn.addEventListener('click', () => {
            const list = missingFieldsModal.querySelector('.missing-fields-list');
            list.innerHTML = getMissingFields()
                .map((name) => `<li class="list-group-item"><i class="bi bi-x-lg text-danger me-2"></i>${name}</li>`)
                .join('');
            const bsModal = new Modal(missingFieldsModal);
            bsModal.show();
        });
        return btn;
    })();

    const updateSubmitButton = () => {
        const submitBtn = document.getElementById('edit-submit') ||
            formActions?.querySelector('input[type="submit"], button[type="submit"]:not([type="button"])');

        if (!submitBtn) return;

        const isValid = formValidation.validateForm(stepElements);
        const isLastStep = activeStepIndex === stepElements.length - 1;

        if (!isValid && isLastStep) {
            submitBtn.hidden = true;
            submitBtn.setAttribute('aria-hidden', 'true');
            if (!infoBtn.parentNode) {
                submitBtn.parentNode.insertBefore(infoBtn, submitBtn);
            }
            infoBtn.hidden = false;
            infoBtn.setAttribute('aria-hidden', 'false');
        } else {
            submitBtn.hidden = !isLastStep;
            submitBtn.setAttribute('aria-hidden', String(!isLastStep));
            infoBtn.hidden = true;
            infoBtn.setAttribute('aria-hidden', 'true');
        }
    };

    const updateContinueButton = (stepIdx) => {
        if (!formActions) return;

        const continueBtn = formActions.querySelector(
            '.form-stepper__actions .btn-primary'
        );
        
        if (!continueBtn) return;

        const fileUploaded = formValidation.hasUploadedFile(stepElements[stepIdx]);
        
        if (fileUploaded) {
            continueBtn.innerHTML = 'Continue <i class="bi bi-arrow-right-short"></i>';
            continueBtn.disabled = false;
        } else {
            continueBtn.textContent = 'Upload file to continue';
            continueBtn.disabled = true;
        }
    };

    const ensureActions = () => {
        if (!formActions) return null;

        let actions = formActions.querySelector('.form-stepper__actions');
        if (!actions) {
            actions = document.createElement('div');
            actions.className = 'form-stepper__actions d-flex justify-content-between';
            formActions.prepend(actions);
        }

        return actions;
    };

    const renderStepperActions = (activeIndex) => {
        const actions = ensureActions();
        if (!actions) return;

        actions.innerHTML = '';

        if (activeIndex > 0) {
            const prevBtn = document.createElement('button');
            prevBtn.type = 'button';
            prevBtn.className = 'btn btn-outline-secondary btn-lg';
            prevBtn.innerHTML = '<i class="bi bi-arrow-left-short"></i> Previous';
            prevBtn.addEventListener('click', () => setActiveStep(activeIndex - 1));
            actions.appendChild(prevBtn);
        } else {
            const spacer = document.createElement('div');
            actions.appendChild(spacer);
        }

        if (activeIndex < stepElements.length - 1) {
            const nextBtn = document.createElement('button');
            nextBtn.type = 'button';
            nextBtn.className = 'btn btn-primary btn-lg align-center w-100';
            nextBtn.innerHTML = 'Continue <i class="bi bi-arrow-right-short"></i>';
            nextBtn.addEventListener('click', () => setActiveStep(activeIndex + 1));
            actions.appendChild(nextBtn);
        }
    };

    const setActiveStep = (activeIndex) => {
        activeStepIndex = activeIndex;

        stepElements.forEach((el, idx) => {
            const isActive = idx === activeIndex;
            el.hidden = !isActive;
            el.setAttribute('aria-hidden', String(!isActive));
        });

        if (formActions) {
            const hideSubmit = activeIndex === 0;
            const submitControls = Array.from(
                formActions.querySelectorAll(
                    'input[type="submit"], button[type="submit"]'
                )
            );
            submitControls.forEach((el) => {
                if (el.tagName === 'BUTTON' && !el.querySelector('.bi-check-lg')) {
                    el.insertAdjacentHTML('afterbegin', '<i class="bi bi-check-lg"></i> ');
                }
                el.hidden = hideSubmit;
                el.setAttribute('aria-hidden', String(hideSubmit));
            });
        }

        renderStepperActions(activeIndex);
        updateContinueButton(activeIndex);

        const activeStep = stepElements[activeIndex];
        const focusTarget = activeStep?.querySelector(
            'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])'
        );
        if (focusTarget) focusTarget.focus({ preventScroll: false });
        activeStep?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    stepElements.forEach((el, idx) => {
        el.setAttribute('role', 'group');
        el.setAttribute('aria-label', `Step ${idx + 1} of ${stepElements.length}`);
    });

    stepElements.forEach((stepEl) => {
        formValidation.observeFormChanges(stepEl, () => {
            updateContinueButton(activeStepIndex);
            updateSubmitButton();
        });
    });

    let initialStep = 0;
    stepElements.forEach((stepEl, idx) => {
        if (stepEl.querySelector('.error, .form-item--error-message')) {
            initialStep = idx;
        }
    });

    setActiveStep(initialStep);
    updateSubmitButton();
};
